import React from 'react';

interface InfoItemProps {
    name?: string;
    value?: string | number | React.JSX.Element | undefined;
    isLoggedIn: boolean;
    isLoading: boolean;
    isDisabled?: boolean;
    isSingleColumn?: boolean;
    defaultValue?: string;
    children?: React.ReactNode;
}
const InfoItem = ({
    isLoggedIn,
    isLoading,
    name,
    value,
    isDisabled,
    children,
    isSingleColumn = false,
    defaultValue = 'XXXX',
}: InfoItemProps) => {
    return (
        <tr>
            {!isSingleColumn && (
                <th scope="row" className="text-start m-0 fw-normal" style={{ fontSize: 12.5 }}>
                    {name}
                </th>
            )}

            <td colSpan={isSingleColumn ? 2 : 1}>
                <div
                    style={{ minWidth: '100px', textAlign: isSingleColumn ? 'justify' : 'left', opacity: 0.9 }}
                    className={`text-sm fw-normal ${
                        isLoading ? 'stripe very-small-stripe rounded-1' : !isDisabled && isLoggedIn ? '' : 'blur-logged-analytics'
                    }`}
                >
                    <span> {isLoading ? '' : !isDisabled && isLoggedIn ? children || value : defaultValue}</span>
                </div>
            </td>
        </tr>
    );
};

export default React.memo(InfoItem);
